import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TableModule} from 'primeng/table';
import {ButtonModule} from 'primeng/button';
import {DialogModule} from 'primeng/dialog';
import {InputTextModule} from 'primeng/inputtext';
import {TextareaModule} from 'primeng/textarea'; // Importante para la descripción
import {ToastModule} from 'primeng/toast';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {MessageService, ConfirmationService} from 'primeng/api';
import {AttributesService} from '../../../core/services/attributes.service';
import {Category} from '../../../shared/models/Attribute';

@Component({
  selector: 'app-categories-admin',
  standalone: true,
  imports: [CommonModule, FormsModule, TableModule, ButtonModule, DialogModule, InputTextModule, TextareaModule, ToastModule, ConfirmDialogModule],
  providers: [MessageService, ConfirmationService],
  templateUrl: './categories-admin.html',
  styleUrls: ['./categories-admin.css']
})
export class CategoriesAdminComponent implements OnInit {
  categories: Category[] = [];
  category: Partial<Category> = {};
  dialog: boolean = false;
  submitted: boolean = false;

  constructor(private service: AttributesService, private messageService: MessageService, private confirmationService: ConfirmationService, private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.load();
  }

  load() {
    this.service.getCategories().subscribe(data => {
      this.categories = data;
      this.cdr.detectChanges();
    });
  }

  openNew() {
    this.category = {isActive: true};
    this.submitted = false;
    this.dialog = true;
  }

  edit(item: Category) {
    this.category = {...item};
    this.dialog = true;
  }

  save() {
    this.submitted = true;
    if (this.category.name?.trim()) {
      const req = this.category.id
        ? this.service.updateCategory(this.category.id, this.category as Category)
        : this.service.createCategory(this.category as Category);

      req.subscribe(() => {
        this.messageService.add({severity: 'success', summary: 'Éxito', detail: 'Categoría guardada'});
        this.load();
        this.dialog = false;
      });
    }
  }

  toggle(item: Category) {
    this.confirmationService.confirm({
      message: `¿Cambiar estado de ${item.name}?`,
      header: 'Confirmar Estado',
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.service.toggleCategory(item.id).subscribe(() => this.load())
    });
  }
}
